export const RecordStates = ['DRAFT', 'REVIEW', 'ACTIVE'] as const;
export type RecordState = typeof RecordStates[number];
